import { useCallback, useRef } from "react";

/** Responses can arrive out of order: a slower, older request must never overwrite what a newer
 * one shows. Each call of the returned function starts a request and returns a check that stays
 * true only until a later request starts, so state is set only from the latest response. */
export function useLatestRequest(): () => () => boolean {
  const latest = useRef(0);
  return useCallback(() => {
    latest.current += 1;
    const mine = latest.current;
    return () => latest.current === mine;
  }, []);
}
